import styled from 'styled-components';

export const NewsWrapper = styled.div`
  .NewsHot {
    padding-top: 200px;
    .container-fluid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 40px;
    }
    .--item {
      &:hover {
        .--name {
          color: var(--color-4) !important;
        }
      }

      &.--newHot {
        height: 484px;
        display: flex;
        flex-flow: column;
        gap: 30px;
        .--txt {
          flex: 0 0 auto;
        }
        .--img {
          flex-grow: 1;
          width: 100%;
          overflow: hidden;
        }
        .--name {
          font-size: 28px;
          color: #000;
        }
        .--time {
          margin-top: 24px;
        }
      }
      .--txt {
        flex-grow: 1;
      }
      .--cate {
        font-size: 12px;
        color: var(--color-1);
        font-weight: 700;
      }
      .--name {
        font-weight: 600;
        margin-top: 8px;
        transition: var(--transition-all);
      }
      .--time {
        color: #858585;
        display: flex;
        align-items: center;
        gap: 8px;
      }
      .--img {
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .--listNews {
      display: flex;
      flex-flow: column;
      gap: 32px;
      .--time {
        margin-top: 12px;
      }
      .--item {
        color: #000;
        display: flex;
        gap: 24px;

        .--name {
          font-size: 18px;
          overflow: hidden;
          text-overflow: ellipsis;
          line-height: 24px;
          -webkit-line-clamp: 2;
          display: -webkit-box;
          -webkit-box-orient: vertical;
        }
        .--img {
          width: 230px;
          height: 140px;
          flex: 0 0 auto;
        }
      }
    }
    @media (max-width: 769px) {
      padding-top: 160px;
      .container-fluid {
        grid-template-columns: repeat(1, 1fr);
      }
      .--listNews {
        .--item {
          flex-flow: column;
          &.--newhot {
            height: auto;
            .--img {
              height: 300px;
            }
          }
          .--img {
            width: 100%;
          }
        }
      }
    }
  }
  .NewsAll {
    padding: 80px 0;
    .--listNews {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-gap: 24px;
      margin-top: 24px;
    }
    .TabPage {
      margin-top: 24px;
    }
    @media (max-width: 769px) {
      padding: 60px 0;
      .--listNews {
        grid-template-columns: repeat(1, 1fr);
      }
    }
  }
`;
